import * as tslib_1 from "tslib";
import { Query } from 'apollo-angular';
import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var QueryDashboardEquipmentsDataGQL = /** @class */ (function (_super) {
    tslib_1.__extends(QueryDashboardEquipmentsDataGQL, _super);
    function QueryDashboardEquipmentsDataGQL() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.document = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query QueryDashboardEquipmentsDataGQL($where: DashboardInput!){\n      accountMaintenancesStatistics(where: $where) {\n        reportName\n        items {\n          key\n          value\n        }\n      }\n    }\n  "], ["\n    query QueryDashboardEquipmentsDataGQL($where: DashboardInput!){\n      accountMaintenancesStatistics(where: $where) {\n        reportName\n        items {\n          key\n          value\n        }\n      }\n    }\n  "])));
        return _this;
    }
    QueryDashboardEquipmentsDataGQL.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function QueryDashboardEquipmentsDataGQL_Factory() { return new QueryDashboardEquipmentsDataGQL(i0.ɵɵinject(i1.Apollo)); }, token: QueryDashboardEquipmentsDataGQL, providedIn: "root" });
    return QueryDashboardEquipmentsDataGQL;
}(Query));
export { QueryDashboardEquipmentsDataGQL };
var templateObject_1;
